import { render } from "./serviceType.vue?vue&type=template&id=0319b8e7&ts=true"
import script from "./serviceType.vue?vue&type=script&lang=ts"
export * from "./serviceType.vue?vue&type=script&lang=ts"

import "./serviceType.vue?vue&type=style&index=0&id=0319b8e7&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__